import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { PopupCustomerExperience, PopupNoContact, PopupTrainingOpportunity, InspectionCommentPopup, PopupSubmitInspection, PopupDuplicateInspections, InspectionScriptPopup } from 'components';
import styles from './InspectionsPopup.css';

class InspectionsPopup extends Component {
  static propTypes = {
    closePopup: React.PropTypes.func,
    textLabel: React.PropTypes.string,
    currentLanguage: React.PropTypes.string,
    insPopupType: React.PropTypes.number,
    strings: React.PropTypes.shape({}),
    wholeData: React.PropTypes.objectOf(React.PropTypes.shape({})),
    ownerId: React.PropTypes.string
  }
  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  popupErrorLabel = strings => (
    <div className={styles.errorLabel}>
      {strings.selectionRequired}
    </div>
  );

  renderPopup = () => {
    if (this.props.insPopupType === 1) {
      return (
        <PopupCustomerExperience
          closeModal={this.props.closePopup}
          wholeData={this.props.wholeData}
          strings={this.props.strings}
          popupErrorLabel={this.popupErrorLabel(this.props.strings)}
        />
      );
    } else if (this.props.insPopupType === 2) {
      return (
        <PopupTrainingOpportunity
          wholeData={this.props.wholeData}
          closePopup={this.props.closePopup}
          strings={this.props.strings}
          popupErrorLabel={this.popupErrorLabel(this.props.strings)}
        />
      );
    } else if (this.props.insPopupType === 3) {
      return (
        <PopupNoContact
          wholeData={this.props.wholeData}
          closePopup={this.props.closePopup}
          strings={this.props.strings}
          popupErrorLabel={this.popupErrorLabel(this.props.strings)}
          ownerId={this.props.ownerId}
        />
      );
    } else if (this.props.insPopupType === 4) {
      return (
        <InspectionCommentPopup
          wholeData={this.props.wholeData}
          strings={this.props.strings}
          closePopup={this.props.closePopup}
        />
      );
    } else if (this.props.insPopupType === 5) {
      return (
        <PopupDuplicateInspections
          wholeData={this.props.wholeData}
          strings={this.props.strings}
          closeModal={this.props.closePopup}
          ownerId={this.props.ownerId}
        />
      );
    } else if (this.props.insPopupType === 6) {
      return (
        <PopupSubmitInspection
          wholeData={this.props.wholeData}
          strings={this.props.strings}
          closeModal={this.props.closePopup}
          ownerId={this.props.ownerId}
        />
      );
    } else if (this.props.insPopupType === 7) {
      return (
        <InspectionScriptPopup
          openPopup
          togglePopupInspectionScript={this.props.closePopup}
          strings={this.props.strings}
          wholeData={this.props.wholeData}
          currentLanguage={this.props.currentLanguage}
        />
      );
    }
    return (
      <div className={styles.popupBody} />
    );
  };

  render() {
    let insPopupType = styles.popup;
    if (this.props.insPopupType === 2) {
      insPopupType = styles.popupLarger;
    } else if (this.props.insPopupType === 4 || this.props.insPopupType === 5) {
      insPopupType = styles.popupSmall;
    } else if (this.props.insPopupType === 6 || this.props.insPopupType === 7) {
      insPopupType = styles.popupWide;
    }
    return (
      <Modal
        isOpen={this.state.open}
        className="modalClass"
        overlayClassName="overlayClass"
      >
        <div className={styles.popupcontainer}>
          <div className={insPopupType}>
            <div className={styles.popupHeader}>
              <div className={styles.popupHeaderDiv}>
                <span
                  className={styles.popupHeaderLabel}
                >
                  {this.props.textLabel}
                </span>
              </div>
            </div>
            {this.renderPopup()}
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect()(InspectionsPopup);



// WEBPACK FOOTER //
// ./src/containers/InspectionsPopup/InspectionsPopup.js